var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-card" }, [
    _c(
      "div",
      { staticClass: "my-card-title" },
      [
        _vm._t("icon", function() {
          return [_c("div", { staticClass: "my-card-title-line" })]
        }),
        _vm._v(" "),
        _vm._t("title", function() {
          return [
            _c("div", {
              staticClass: "my-card-title-label",
              domProps: { textContent: _vm._s(_vm.title) }
            })
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "my-card-content" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06f91f0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f91f0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyCard.vue
// module id = 5KKM
// module chunks = 38